/** @jsxImportSource @emotion/react */
import React, { useEffect, useRef, useState } from 'react';
import * as s from './style'
import TileLayer from 'ol/layer/Tile';
import ImageLayer from 'ol/layer/Image';
import { GEOSERVER } from 'config/URL/URL';
import { ImageWMS, TileWMS, XYZ } from 'ol/source';
import { Map, Overlay, View } from 'ol';
import Attribution from 'ol/control/Attribution';
import YearDisplay from './year_display/YearDisplay';
import { resolve } from 'mathjs';

const CustomMap = ({ selectedCategory }) => {
    const mapRef = useRef();
    const [ selectedYear, setSelectedYear ] = useState();
    const [ yearArray, setYearArray ] = useState();
    
    useEffect(() => {
        setInitMap();
    }, [])

    useEffect(() => {
        if(!selectedCategory) return;

        const startYear = parseInt(selectedCategory.start_yyyy);
        const endYear = parseInt(selectedCategory.end_yyyy);

        const newYearArray = Array.from({ length: endYear - startYear + 1}, (_, index) => (endYear - index));

        setYearArray(newYearArray);

        const newLayers = setLayers(newYearArray, startYear);

        
        return () => {
            setSelectedYear();

            newLayers?.forEach((layer) => {
                mapRef.current.removeLayer(layer);
            })
        }

    }, [selectedCategory]);

    useEffect(() => {
        if(!selectedCategory || !selectedYear) return;

        const startYear = parseInt(selectedCategory.start_yyyy);
        const endYear = parseInt(selectedCategory.end_yyyy);

        const dataLayers = getDataLayers();
        const currentLayer = dataLayers.find((layer) => layer.get("layerName") === `dataLayer_${selectedYear}`);
        const invisibleLayers = dataLayers.filter((layer) => layer.get("layerName") !== `dataLayer_${selectedYear}`);
        
        currentLayer.setVisible(true);
        invisibleLayers.forEach((layer) => 
            layer.setVisible(false)
        )

        const timeout = setTimeout(() => {
            if(selectedYear === endYear) {
                setSelectedYear(startYear)
            } else {
                setSelectedYear(selectedYear + 1)
            }
        }, 3000)

        return () => {
            clearTimeout(timeout);
        }


    }, [selectedYear])

    const setInitMap = () => {
        if(!mapRef.current) {
            const vworldLayer = new TileLayer({
                title: 'VWorld white Map',
                visible: true,
                type: 'white',
                source: new XYZ({
                    url: 'https://xdworld.vworld.kr/2d/white/service/{z}/{x}/{y}.png',
                    attributions: '&copy; <a href="http://map.vworld.kr">V-World Map</a>'
                })
            })

            const sidoWmsLayer = new ImageLayer({
                properties: {
                    layerName: 'sido_wms'
                },
                source: new ImageWMS({
                    url: GEOSERVER + '/geoserver1/wms',
                    params: { 'LAYERS': 'gis_solution:ts_admin_sido' },
                    ratio: 1,
                    serverType: 'geoserver',
                }),
                opacity: 0.8,
                zIndex: 99
            })

            const sggWmsLayer = new ImageLayer({
                properties: {
                    layerName: 'sgg_wms'
                },
                source: new ImageWMS({
                    url: GEOSERVER + '/geoserver1/wms',
                    params: { 'LAYERS': 'gis_solution:ts_admin_sgg' },
                    ratio: 1,
                    serverType: 'geoserver',
                }),
                opacity: 0.8,
                zIndex: 98
            })

            const view = new View({
                center: [1.422617405965338E7, 4294546.35698363],
                zoom: 7.5,
                maxZoom: 13,
                minZoom: 7
            })

            const overlay = new Overlay({
                element: document.getElementById('popup'),
                autoPan: true,
                autoPanAnimation: {
                duration: 250,
                },
            });

            const map = new Map({
                layers: [ vworldLayer, sidoWmsLayer, sggWmsLayer ],
                target: "map_area",
                view: view,
                overlays: [overlay]
            });

            const attribution = new Attribution({
                collapseLabel: "»"
            })
            map.addControl(attribution)

            mapRef.current = map;
        }
    }

    const getDataLayerSource = (year, category_nm_en) => {
        const dataLayerSource = new TileWMS({
            url: GEOSERVER + '/geoserver/wms',
            params: {
                'LAYERS': 'gis_solution:vl_data',
                'viewparams': 'year:' + year + ';keyword:' + category_nm_en + ';',
                'STYLES': 'sty_' + category_nm_en + '_sgg',
            },
            ratio: 1,
            serverType: 'geoserver',
        })
    
        return dataLayerSource;
    }

    const getDataLayers = () => {
        const dataLayers = mapRef.current.getLayers().getArray().filter((layer) => {
            const layerName = layer.get("layerName");
            return layerName && layerName?.includes("dataLayer");
        });

        return dataLayers;
    }

    const setLayers = (newYearArray, startYear) => {
        const newLayers = newYearArray.map((year) => {
            const newLayer = new TileLayer({
                properties: {
                    layerName: `dataLayer_${year}`
                },
                source: getDataLayerSource(year, selectedCategory.nm_en),
                zIndex: year === startYear ? 97 : 96
            });

            return newLayer;
        })

        newLayers.forEach((layer) => {
            mapRef.current.addLayer(layer);
        });

        mapRef.current.once('loadend', () => {
            setSelectedYear(startYear);
        })
        

        return newLayers;
    }



    return (
        <div css={s.mainContainer}>
            <div id="map_area" css={s.mapArea}>
                <div css={s.mapPost}>
                    <div css={s.legend}>
                        { selectedCategory && <img src={`images/range/${selectedCategory.nm_en}.png`} alt={selectedCategory.nm_en}/> }
                    </div>
                </div>
                <YearDisplay yearArray={yearArray} selectedYear={selectedYear}/>
            </div>
        </div>
    );
};

export default CustomMap;